/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Review_EvasionInputs */

const en_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review evasion`)
};

const ar_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجاوز المراجعة`)
};

const bn_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিভিউ ইভেশন`)
};

const de_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertungsumgehung`)
};

const es_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evasión de revisión`)
};

const fr_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évasion des avis`)
};

const pt_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evasão de revisão`)
};

const zh_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审查规避`)
};

const tr_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İncelemeden kaçınma`)
};

const ru_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уклонение от просмотра`)
};

const pl_svchip_review_evasion = /** @type {(inputs: Svchip_Review_EvasionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź uchylanie się od płacenia podatków`)
};

/**
* | output |
* | --- |
* | "Review evasion" |
*
* @param {Svchip_Review_EvasionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_review_evasion = /** @type {((inputs?: Svchip_Review_EvasionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Review_EvasionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_review_evasion(inputs)
	if (locale === "bn") return bn_svchip_review_evasion(inputs)
	if (locale === "de") return de_svchip_review_evasion(inputs)
	if (locale === "es") return es_svchip_review_evasion(inputs)
	if (locale === "fr") return fr_svchip_review_evasion(inputs)
	if (locale === "pt") return pt_svchip_review_evasion(inputs)
	if (locale === "zh") return zh_svchip_review_evasion(inputs)
	if (locale === "tr") return tr_svchip_review_evasion(inputs)
	if (locale === "ru") return ru_svchip_review_evasion(inputs)
	if (locale === "pl") return pl_svchip_review_evasion(inputs)
	return en_svchip_review_evasion(inputs)
});